import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { AuthGuard } from '../../authGuard/auth.guard';
import { BiscommunicationComponent } from './biscommunication/biscommunication.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { NgSelectModule } from '@ng-select/ng-select';

import { BISCommunicationService } from './../../services/BISCommunication.service';
import { UserMasterService } from './../../services/user-master.service';

export const routes: Routes = [
  {
    path: 'BIS',
    component: BiscommunicationComponent,
    canActivate: [AuthGuard],
    outlet: 'structure-outlet',
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    DataTablesModule,
    NgSelectModule,
  ],
  declarations: [BiscommunicationComponent],
  providers: [BISCommunicationService, UserMasterService],
})
export class BISModule {}
